import React from 'react'
import { Switch, Route, Redirect } from 'react-router'

import Dashboard from '../dashboard/dashboard'
import Usuario from '../usuario/usuario'
import Unidade from '../unidade/unidade'
import Boleto from '../boleto/boleto'
import Carne from '../carne/carne'
import Automatizacao from '../rotinaautomatica/rotina_automatica'
import configuracao from '../configuracoes/configuracao'

export default props => (
    <div className='content-wrapper'>
        <Switch>
            <Route exact path='/' component={Dashboard} />
            <Route path='/usuarios' component={Usuario} />
            <Route path='/unidades' component={Unidade} />
            <Route path='/boletos' component={Boleto} />
            <Route path='/carnes' component={Carne} />
            <Route path='/aut_carne' component={Automatizacao} />
            <Route path='/configuracao' component={configuracao} />
            <Redirect from='*' to='/' />
        </Switch>
    </div>
)


// WEBPACK FOOTER //
// ./src/main/routes.jsx